import type { FaireProductEntity } from "../../entity_types/product";

export const p_dxwgdcr6pr: FaireProductEntity = {
  token: "p_dxwgdcr6pr",
  type: "product",
  name: "Men's Hooded Zip-Up Sweatshirt With Pockets Jacket",
  brandToken: "b_j2hghp5gvd",
  brandName: "Mirazshoes WholeSale",
  imageUrl:
    "https://cdn.faire.com/fastly/a1f64c95a1f2d162025f3048e6256f01b8a89fd6b2e652f6b260ddb1326737d6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fdb448320c9fe1b0d88fe030eeee9a7fbcdc48c1ff6bd9a9b837288ad54956d4.jpeg",
    "https://cdn.faire.com/fastly/b5061492693cf2e4e0a5e1978b9bb0f87b25a0fccd5e1bf94838c4d810ad9bfb.jpeg",
    "https://cdn.faire.com/fastly/8f328ba95168fa5db2b126047eb037a73db3ca8fbc7f9a65b6504fdceada307d.jpeg",
    "https://cdn.faire.com/fastly/ab4f6de5b4cb944f3d73fd722f79ac24ddb3cc90bca517746a6b2d208fe807c2.jpeg",
    "https://cdn.faire.com/fastly/873fd38dcf644963a645d9b15e2cd01507f331adee991dbcf5a1998309300c67.jpeg",
    "https://cdn.faire.com/fastly/865d4f92ae3a6182f40fc616df1f297ebe7fcb50bf71797247ce6c7072d2402b.jpeg",
    "https://cdn.faire.com/fastly/b522368e6c37fabc74d6fc8c7b8aee0d008286826de87ce7a898d0ad195c40af.jpeg",
    "https://cdn.faire.com/fastly/6b5559f245156f666fa54e96102037904a0a714dd96cf00483e43ed94a3b9f66.jpeg",
    "https://cdn.faire.com/fastly/be3e7ffd842b3ca3ee55ef634758bb8d4ff2147526a03fd74b75ab9744834665.jpeg",
    "https://cdn.faire.com/fastly/41c6b5333136c94810c1fbfe61fa23655b09eab80f2fbd4a2cedb90ea7d57bbb.jpeg",
  ],
  priceDollars: 15.49,
  description: "",
  tags: [],
  msrpDollars: 30.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:39.839Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
